<template>
    <div class="searchPackage-listItem" :style="cruiseBg(cruise)" >
        <a class="listItem-cruiseName external" @click="goToCruiseDetail()">{{cruise.cruiseName}}</a>
        <div class="item-refund" v-if="cruise.isSevenDayNrpCruise">
            <img src="https://resource.rcclchina.com.cn/cruiseSearch/ease_refund_7_day.png"/>
        </div>
        <div class="item-refund" v-if="cruise.isShowRefund">
            <img src="https://resource.rcclchina.com.cn/cruiseSearch/ease_refund_update.png"/>
        </div>
        <div class="listItem">
          <div class="listItem-cruiseInfo">
            <a class="listItem-cruiseInfo-pic external" @click="goToCruiseDetail()">
              <img :src="cruise.mobileImage" v-if="cruise.mobileImage && cruise.mobileImage.length > 0" />
              <div class="listItem-cruiseInfo-picTitle"><span v-html="supportDescription"></span></div>
            </a>
            <div v-if="isHot" class="listItem-cruiseInfo-tips">爆款</div>
            <div class="listItem-cruiseInfo-right">
              <div class="listItem-cruiseInfo-right-box1">
                <div class="listItem-cruiseInfo-prompt">
                  <div v-if="cruise.isSoldOut" class="cruiseInfo-promptSellOut">
                    <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/sellOutIcon.png" />
                    <span>即将售罄</span>
                  </div>
                </div>
                <div class="listItem-cruiseInfo-sailDays"><span>{{routeDaysStr}}</span><span style="margin-left: 15px;">{{cruise.shipCNName}}</span></div>
                <div class="listItem-cruiseInfo-sailDate" @click="onCruiseCalendarClick()">
                  <span>{{sailDateBegin}} <i>—</i> {{sailDateEnd}}</span>
                  <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/calendarIcon.png" class="js-getCruiseByRoute" />
                </div>
                <a class="listItem-cruiseInfo-tags-box external" @click="goToCruiseDetail()">
                  <div class="listItem-cruiseInfo-tags">
                    <span v-for="(tag, i) in tags" :key="i"  :class="{highShow: tag.isHighShow}">{{tag.tagType}}</span>
                  </div>
                </a>
              </div>
              <div class="listItem-cruiseInfo-right-box2">
                <div class="listItem-cruiseInfo-perPrice">
                  <a style="border:none;" class="external" @click="goToCruiseDetail()">
                    {{nrpText}}(含税)&nbsp;&nbsp;<span class="cruisePrice-per"><span>¥</span>{{netAmount}}</span> /人起
                  </a>
                </div>
                <div class="listItem-cruiseInfo-perNight">
                  <p style="border:none;" class="external" @click="goToCruiseDetail()">
                    平均每晚<span style="margin-left: 8px;">¥{{amountPerNight}}/人起</span>
                  </p>
                </div>
<!--                <div v-if="isShowPopular" class="listItem-cruiseInfo-perNight">-->
<!--                  <span class="listItem-cruiseInfo-popularTag">人气</span>-->
<!--                  <span v-if="cruise.searchCount>10">-->
<!--                            <span class='popular-number' >{{cruise.searchCount}}</span>人搜索-->
<!--                        </span>-->
<!--                  <span v-if="cruise.bookingCount>10">-->
<!--                            <span class='popular-number'>{{cruise.bookingCount}}</span>人预订-->
<!--                        </span>-->
<!--                </div>-->
              </div>
              <div class="listItem-like js-wishBtn" :class="{ active: cruise.inWish}" @click="onWishListClick()">
                <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/likeIcon.png" />
                <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/likeActiveIcon.png" />
                <span class="wish-num">{{cruise.collections}}</span>
              </div>
            </div>
          </div>
          <div class="nearRoute" v-if="cruise.isNearRoute">*此航线为临近航线，请联系在线客服或拨打400-820-7293进行预订</div>
          <div class="nearRoute" v-if="!cruise.isSale && !cruise.isNearRoute">*此航线不可售卖，请联系在线客服或拨打400-820-7293进行预订</div>
        </div>
      <div class="nearRoutePopup" v-if="isShowNearRoutePopups">
        <div class="nearRoute-main">
            <div class="near-title">温馨提示</div>
            <div class="near-text">此航线{{ routePopupText }}，请联系在线客服或拨打400-820-7293进行预订。</div>
            <div class="near-btn" @click="closeRoutePopup">我知道了</div>
        </div>
      </div>
    </div>
</template>

<script>
import api from '@/api'
import { gioTracking } from "@/utilities/tools";
export default {
    name: 'SearchCruiseItem',
    props: {
        cruise: {
            type: Object,
            default () {
                return {}
            }
        }
    },
  data(){
      return{
        isShowNearRoutePopups:false,
        routePopupText:''
      }
  },
    methods: {
        onCruiseCalendarClick () {
            if(this.cruise.isNearRoute){
              this.isShowNearRoutePopups = true
              this.routePopupText = '为临近航线'
              return
            }
            if(!this.cruise.isSale){
              this.isShowNearRoutePopups = true
              this.routePopupText = '不可售卖'
              return
            }
            this.$router.push({ name: 'CruiseCalendar', query:{
                shipCode: this.cruise.shipCode,
                sailDate: this.cruise.sailDate,
                routeCode: this.cruise.cruiseName
                }})
        },
        goToCruiseDetail () {
            gioTracking('track', 'evt_CruiseList', {
                shipCode:this.cruise.shipCode || 'nil',
                sailDate:this.cruise.sailDate || 'nil'
            })
            if(this.cruise.isNearRoute){
              this.isShowNearRoutePopups = true
              this.routePopupText = '为临近航线'
              return
            }
            if(!this.cruise.isSale){
              this.isShowNearRoutePopups = true
              this.routePopupText = '不可售卖'
              return
            }
            this.$router.push({ name: 'CruiseDetail'
                , query: { shipCode: this.cruise.shipCode, sailDate: this.cruise.sailDate } })
        },
        onWishListClick () {
            if (this.cruise.inWish) {
                this.deleteWishList()
            } else {
                this.addWishList()
            }
        },
        async addWishList () {
            const userToken = this.$store.state.user.userToken
            if (!userToken || userToken.length == 0) {
                let self = this
                this.$confirm.show('您尚未登录， 请登录之后， 再添加至心愿单', {
                    confirmCallBack: () => {
                        self.$router.push({ name: 'Login', query:{
                            returnUrl: location.href
                        }})
                    }
                })
                return
            }
            const requestData = {
                userName: userToken,
                cruiseId: this.cruise.cruiseId,
                source: 'mobile'
            }
            this.$loading.show()
            const { success } = await api.cruise.addWishList(requestData)
            if (success) {
                this.cruise.inWish = true
                this.cruise.collections++
            }
            this.$loading.hide()
        },
        async deleteWishList () {
            const userToken = this.$store.state.user.userToken
            if (!userToken || userToken.length == 0) {
                let self = this
                this.$confirm.show('您尚未登录， 请登录之后， 再添加至心愿单', {
                    confirmCallBack: () => {
                        self.$router.push({ name: 'Login', query:{
                            returnUrl: location.href
                        }})
                    }
                })
                return
            }
            const requestData = {
                userName: userToken,
                cruiseId: this.cruise.cruiseId,
                source: 'mobile'
            }
            this.$loading.show()
            const { success } = await api.cruise.deleteWishList(requestData)
            if (success) {
                this.cruise.inWish = false
                if (this.cruise.collections > 0) {
                    this.cruise.collections--
                }
            }
            this.$loading.hide()
        },
        // 关闭确认弹窗
        closeRoutePopup(){
            this.isShowNearRoutePopups = false
            this.routePopupText = ''
        },
        cruiseBg(obj) {
          let cruiseBg = "";
          if(obj.backgroundImageCategory && obj.backgroundImageCategory === "QIAOHU") {
            cruiseBg = `background-image: url('${obj.mbCruiseBackgroundImage}');`;
          }
          if(obj.isNearRoute || !obj.isSale) {
            cruiseBg = "background-color:#E5E5E5";
          }
          return cruiseBg
        }
    },
    computed: {
        supportDescription () {
            const supportDescription = this.cruise.supportDescription
            if (supportDescription && supportDescription.length > 0) {
                return supportDescription.replace(' ', '<br/>')
            }
            return ''
        },
        sailDateBegin () {
            return this.cruise.sailDateBegin ? this.cruise.sailDateBegin.split(' (')[0] : ""
        },
        sailDateEnd () {
            return this.cruise.sailDateEnd ? this.cruise.sailDateEnd.split(' (')[0] : ""
        },
        cruiseUrl () {
            return "/Rccl.Cruise/CruiseDetail?sailDate="+this.cruise.sailDate + "&shipCode="+this.cruise.shipCode
		+ "&guestNumber=" + this.cruise.guestNumber
        },
        isHot () {
            return this.cruise.choosenSupport
        },
        routeDaysStr () {
            return this.cruise.routeDays + "天" + (this.cruise.routeDays - 1) + "晚"
        },
        tags () {
            return this.cruise.tags ? this.cruise.tags.filter(r=>r.tagType && r.tagType.length > 0) : []
        },
        nrpText () {
            return this.cruise.isnrpPrice ? "早订特惠价" : "优惠价"
        },
        netAmount () {
            return this.cruise.netAmount ? this.cruise.netAmount.toFixed(0): ""
        },
        amountPerNight() {
            return this.cruise.amountPerNight ? this.cruise.amountPerNight.toFixed(0) : ""
        },
        isShowPopular () {
            return (this.cruise.bookingCount >= 10 || this.cruise.searchCount >= 10)
            && (this.cruise.bookingCount + this.cruise.searchCount) >= 100
        }

    }
}
</script>
